class CustomLogin {
    constructor() {
        this.url = window.location.href;
        this.urlParams = new URLSearchParams(window.location.search);
        //console.log('customLogin.js loaded');
        this.init();
    }

    removeQueryStringByKey(key, url) {
        url = url.replace(new RegExp(key + "=\\w+"), "").replace("?&", "?").replace("&&", "&");
        return (url[url.length - 1] === '?') ? url.slice(0, -1) : url;
    }

    cleanUrl(key, url) {
        history.pushState(null, "", this.removeQueryStringByKey(key, url));
    }

    handleEvents() {
        document.querySelector('.customResetButton')?.addEventListener('click', () => {
            document.querySelector('.account-login').click();
            document.querySelector('[data-recover-link]').click();
        });
        document.addEventListener("click", function (event) {
            const loginDrawer = document.querySelector(".customLoginDrawer");
            const closeButton = document.querySelector(".customCloseButton");
        if(!event.target.classList.contains('customLoginButton')){
            
                 // Check if the drawer exists and is open
                 if (loginDrawer && loginDrawer.classList.contains("open")) {
                    // Check if the click is outside the drawer or on the close button
                    if (!loginDrawer.contains(event.target) || closeButton.contains(event.target)) {
                        loginDrawer.classList.remove("open");
                    }
                }
        }
       
        });
        

        const closeButton = document.querySelector(".customCloseButton");
        closeButton?.addEventListener("click", () => {
            document.querySelector('.customLoginDrawer').classList.remove('open');
            document.body.classList.remove('scroll-fixed');
            document.querySelector('#site-overlay').classList.remove('overlay--body');
        });

        document.querySelectorAll('.customLoginButton').forEach(button => {
            button.addEventListener('click', () => {
                // //console.log('Login button clicked', document.querySelector('.customLoginDrawer'));
                
                document.querySelector('.customLoginDrawer').classList.add('open');
                document.body.classList.add('scroll-fixed');
                document.querySelector('#site-overlay').classList.add('overlay--body');
            });
        });

        document.querySelectorAll('.customLoginRegisterToggle').forEach(toggle => {
            toggle.addEventListener('click', () => {
                document.querySelectorAll('#accountTabs .tabcontent').forEach(tabContent => {
                    tabContent.style.display = 'none';
                    if (toggle.getAttribute('aria-controls') === tabContent.getAttribute('id')) {
                        tabContent.style.display = 'block';
                    }
                });
            });
        });

        document.querySelector('[data-recover-link]')?.addEventListener('click', () => {
            document.querySelector('#customerLoginForm').style.display = 'none';
            document.querySelector('.account-login-signup-header').classList.add('d-none');
            document.querySelector('.account-login-signup-header').classList.remove('d-flex');
            document.querySelector('.account-tabs').classList.add('d-none');
            document.querySelector('.account-tabs').classList.remove('d-flex');
            document.querySelector('[data-recover-password-form]').style.display = 'block';
        });

        document.querySelector('[data-hideresetpass]')?.addEventListener('click', () => {
            document.querySelector('#customerLoginForm').style.display = 'block';
            document.querySelector('.account-login-signup-header').classList.remove('d-none');
            document.querySelector('.account-login-signup-header').classList.add('d-flex');
            document.querySelector('.account-tabs').classList.remove('d-none');
            document.querySelector('.account-tabs').classList.add('d-flex');
            document.querySelector('[data-recover-password-form]').style.display = 'none';
        });
    }

    handleUrlConditions() {
        if (this.url.includes("?logged_in=true")) {
            console.log('User is logged in');
            this.cleanUrl('logged_in', this.url);
            document.querySelector('.customLoginDrawer').classList.add('open');
            document.body.classList.add('scroll-fixed');
            document.querySelector('#site-overlay').classList.add('overlay--body');
        }
 
        if (this.url.includes("?login_attempted=false")) {
            this.cleanUrl('login_attempted', this.url);
            document.querySelector('.customLoginDrawer').classList.add('open');
            document.body.classList.add('scroll-fixed');
            document.querySelector('#site-overlay').classList.add('overlay--body');
            document.querySelector('.errorMessageCustom')?.classList.remove('d-none');
        }

        if (this.url.includes("?registered=true")) {
            this.cleanUrl('registered', this.url);
            console.log(document.querySelector(".account-register"), 'register');
            document.querySelector('.customLoginDrawer').classList.add('open');
            document.body.classList.add('scroll-fixed');
            document.querySelector('#site-overlay').classList.add('overlay--body');
            setTimeout(() => {
                document.querySelector(".account-register").click();
            }, 500);
        }

        if (this.url.includes("recovered=true")) {
            this.cleanUrl('recovered', this.url);
            setTimeout(() => {
                document.querySelector('[data-recover-link]').click();
                document.querySelector('.errorMessageCustomRecover').classList.remove('d-none');
            }, 500);
            document.querySelector('.customLoginDrawer').classList.add('open');
            document.body.classList.add('scroll-fixed');
            document.querySelector('#site-overlay').classList.add('overlay--body');
        }
    }

    init() {
        //console.log('The DOM is ready to be interacted with!');
        this.handleEvents();
        this.handleUrlConditions();
    }
}

// Initialize the class
new CustomLogin();